<template>
    <v-dialog v-model="dialog"  >

        <v-card v-if="deslinde"   >
            <v-card-title>
                <span class="headline">{{ dialogTitle }}</span>
            </v-card-title>
            <v-card-text   >

                <h4 class=" ">Vista Previa</h4>
                <PDFViewer
                    :source="deslinde.download_url "
                    style="height: 600px; width: 100%"
                    :controls="[]"           
                    :loading-text="'Cargando Deslinde...'"
                    :rendering-text="'Renderizando Deslinde...'"    
                    @loading-failed="() => { console.log('Failed to load PDF'); alert('Failed to load PDF') }"                                
                />
                <div v-if="deslinde.status == 'APPROVED' "  >
                    <v-alert type="success" outlined v-show="true">
                        Deslinde Aprobado
                    </v-alert>
                </div>
                <div v-if="deslinde.status == 'REJECTED' "  >
                    <v-alert type="warning" outlined v-show="true">
                        Deslinde Rechazado
                    </v-alert>
                    <v-alert type="warning" outlined v-show="true">
                        <p>La firma del deslinde fue rechazada, el participante puede volver a firmarla en la siguiente url:</p>

                        <p>
                            {{signUrl}}{{deslinde.access_token}}
                        </p>

                    </v-alert>

                </div>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div v-if="deslinde.status == 'PENDING' "  style="text-align: right;" >
                    <v-btn :loading="loadingValidation" dark color="warning" @click="rechazarDeslinde( )">
                        <v-icon left>close</v-icon> Rechazar Deslinde
                    </v-btn>
                    <v-btn :loading="loadingValidation"  dark color="green" @click="aprobarDeslinde( )">
                        <v-icon left>check</v-icon> Aprobar el Deslinde
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import deslinde from '../../../../../api/deslinde';
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
import CanAccess from '../../../../../components/utils/CanAccess.vue';
import LabelEstado from '../../../../../components/common/LabelEstado.vue';
import api from "../../../../../api/inscripcion";

export default {
    props: {
        evento_id: {
            type: Number
        }
    },
    components: { CanAccess: CanAccess, LabelEstado: LabelEstado , PDFViewer: PDFViewer},
    data() {
        return {
            dialog: false,
            dialogTitle: 'Validar Deslinde',
            deslinde_id: null,
            deslinde: null,
            loadingValidation: false,
            signUrl : process.env.VUE_APP_HOST_URL  + '/#/firmar-deslinde/',
        }
    },
    computed: {

    },
    watch: {
        dialog: function (val) {
            if (!val) {
                this.deslinde = null;
                this.$emit('close');
            }   
        }
    },
    methods: {
        openValidarFirma(item) {
            this.deslinde = null;
            this.dialogTitle = 'Validar firma';
            this.deslinde = item;
            this.dialog = true;
        },
        rechazarDeslinde( ) {
            this.loadingValidation = true;
            api.rechazarDeslinde( this.deslinde.inscripcion_id, this.deslinde.id).then((response) => {
                
                 this.loadingValidation = false;
                 this.loadingValidation = false;
                 this.$emit('reloadDeslindes', this.deslinde);                 
                 this.dialog = false;
                 this.deslinde = null;
                

            }).catch((error) => {
                console.log(error);
            });
        },


        aprobarDeslinde() {
            this.loadingValidation = true;
            api.aprobarDeslinde( this.deslinde.inscripcion_id, this.deslinde.id).then((response) => {
                
                 this.loadingValidation = false;
                 this.$emit('reloadDeslindes', this.deslinde);
                 this.dialog = false;
                 this.deslinde = null;

            }).catch((error) => {
                console.log(error);
            });
        }

     
    }
}

</script>